import { defineStore } from "pinia";

export const useNotificationsStore = defineStore("notifications", {
	state: () => {
		return {
			newNotificationsCount: 0,
			notifications: [],
			notificationsPage: 0,
		};
	},
	actions: {
		setNewNotificationsCount(count) {
			this.newNotificationsCount = count;
		},
		setNotifications(items) {
			this.notifications = items;
		},
		setNotificationsPage(page) {
			this.notificationsPage = page;
		},
		addNotification(item: any) {
			this.notifications.push(item);
		},
		removeNotification(itemId: any) {
			let currentNotification = this.notifications;
			currentNotification = currentNotification.filter((obj) => {
				return obj.entity_id !== itemId;
			});
			this.notifications = currentNotification;
		},
	},
});
